import { render, staticRenderFns } from "./SkillSearchBehaviourSelector.vue?vue&type=template&id=0bf85f1d&scoped=true&"
import script from "./SkillSearchBehaviourSelector.vue?vue&type=script&lang=ts&"
export * from "./SkillSearchBehaviourSelector.vue?vue&type=script&lang=ts&"
import style0 from "./SkillSearchBehaviourSelector.vue?vue&type=style&index=0&id=0bf85f1d&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bf85f1d",
  null
  
)

export default component.exports